import { createContext } from "react";
import { createContextualCan } from "@casl/react";
import { type AnyAbility, createMongoAbility } from "@casl/ability";

export const AbilityContext = createContext<AnyAbility>(createMongoAbility());
export const Can = createContextualCan(AbilityContext.Consumer);
